// V3 JOB APPLICANT STATS *************************************************************************
// pathname: /v3/{jobSlug}/applicant-stats
// ************************************************************************************************
import { useSwrApi, ApiApplicationStats, ApiApplicationStatsList } from 'src/hooks/useSwrApi';


/**
 * @description SWR: fetch the stats for the applicants of a job (interview, rejected, etc.).
 * @param jobSlug - the job slug
 * @param locale - the locale
 * @param serverSideData - the server side data
 */
export const useSwrApplicantStats = (jobSlug: string, locale = 'ro', serverSideData?: ApiApplicationStatsList) => {
  const {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSwrApi<ApiApplicationStats[]>({
    url: `/v3/${jobSlug}/applicant-stats`,
    locale,
    serverSideData,
    shouldFetch: !!jobSlug,
    apiOptions: {
      dedupingInterval: 1000 * 60 * 5, // 5 minutes
    },
  });

  // Return data
  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};
